/**
 * LLM formatting utilities.
 *
 * Kept in a dedicated module to avoid Fast Refresh export-shape issues in component files.
 */

export const formatPluginName = (pluginId: string): string => {
  const parts = pluginId.split(":");
  if (parts.length > 1) {
    return parts[1]
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  return pluginId;
};
